import { TranslationService } from "../../../services/TranslationService";
import Loading from "../../shared/components/Loading";

/** Loading state while the agenda is generated (30-70 s). */
const AgendaGenerating = () => (
  <div className="agenda-card agenda-empty" role="status" aria-live="polite">
    <Loading height={90} />
    <p className="agenda-empty__text">
      {TranslationService.translate.AgendaGenerating}
    </p>
  </div>
);

export default AgendaGenerating;
